import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from './axiosBaseQuery'
import { baseUrl } from './axiosInstance'

const templateApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'templateApi',
  tagTypes: ['template', 'templateList', 'advertisement'],
  endpoints: () => ({})
})

export default templateApi
